export const GET_ORDERS = 'src/pages/orders/GET_ORDERS';
export const GET_ORDERS_SUCCESS = 'src/pages/orders/GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILED = 'src/pages/orders/GET_ORDERS_FAILED';

export const GET_CAT = 'src/pages/orders/GET_CAT';
export const GET_CAT_SUCCESS = 'src/pages/orders/GET_CAT_SUCCESS';
export const GET_CAT_FAILED = 'src/pages/orders/GET_CAT_FAILED';

export const GET_TICKETS = 'src/pages/orders/GET_TICKETS';
export const GET_TICKETS_SUCCESS = 'src/pages/orders/GET_TICKETS_SUCCESS';
export const GET_TICKETS_FAILED = 'src/pages/orders/GET_TICKETS_FAILED';

export const GET_TICKET = 'src/pages/orders/GET_TICKET';
export const GET_TICKET_SUCCESS = 'src/pages/orders/GET_TICKET_SUCCESS';
export const GET_TICKET_FAILED = 'src/pages/orders/GET_TICKET_FAILED';

export const CLOSE_TICKET = 'src/pages/orders/CLOSE_TICKET';
export const CLOSE_TICKET_SUCCESS = 'src/pages/orders/CLOSE_TICKET_SUCCESS';
export const CLOSE_TICKET_FAILED = 'src/pages/orders/CLOSE_TICKET_FAILED';

export const GET_TICKETCOUNT = 'src/pages/orders/GET_TICKETCOUNT';
export const GET_TICKETCOUNT_SUCCESS =
  'src/pages/orders/GET_TICKETCOUNT_SUCCESS';
export const GET_TICKETCOUNT_FAILED = 'src/pages/orders/GET_TICKETCOUNT_FAILED';

export const GET_PROVINCES = 'src/pages/orders/GET_PROVINCES';
export const GET_PROVINCES_SUCCESS = 'src/pages/orders/GET_PROVINCES_SUCCESS';
export const GET_PROVINCES_FAILED = 'src/pages/orders/GET_PROVINCES_FAILED';

export const GET_CITIES = 'src/pages/orders/GET_CITIES';
export const GET_CITIES_SUCCESS = 'src/pages/orders/GET_CITIES_SUCCESS';
export const GET_CITIES_FAILED = 'src/pages/orders/GET_CITIES_FAILED';

export const CREATE_POST_ORDERS = 'src/pages/orders/CREATE_POST_ORDERS';
export const CREATE_POST_ORDERS_SUCCESS =
  'src/pages/orders/CREATE_POST_ORDERS_SUCCESS';
export const CREATE_POST_ORDERS_FAILED =
  'src/pages/orders/CREATE_POST_ORDERS_FAILED';

export const GET_POST_ORDERS = 'src/pages/orders/GET_POST_ORDERS';
export const GET_POST_ORDERS_SUCCESS =
  'src/pages/orders/GET_POST_ORDERS_SUCCESS';
export const GET_POST_ORDERS_FAILED = 'src/pages/orders/GET_POST_ORDERS_FAILED';

export const GET_ALL_POST_ORDERS = 'src/pages/orders/GET_ALL_POST_ORDERS';
export const GET_ALL_POST_ORDERS_SUCCESS =
  'src/pages/orders/GET_ALL_POST_ORDERS_SUCCESS';
export const GET_ALL_POST_ORDERS_FAILED =
  'src/pages/orders/GET_ALL_POST_ORDERS_FAILED';

export const GET_ORDERS_PRINT = 'src/pages/orders/GET_ORDERS_PRINT';
export const GET_ORDERS_PRINT_SUCCESS =
  'src/pages/orders/GET_ORDERS_PRINT_SUCCESS';
export const GET_ORDERS_PRINT_FAILED =
  'src/pages/orders/GET_ORDERS_PRINT_FAILED';

export const GET_ORDER_WITH_ID = 'src/pages/orders/GET_ORDER_WITH_ID';
export const GET_ORDER_WITH_ID_SUCCESS =
  'src/pages/orders/GET_ORDER_WITH_ID_SUCCESS';
export const GET_ORDER_WITH_ID_FAILED =
  'src/pages/orders/GET_ORDER_WITH_ID_FAILED';

export const GET_POST_ORDER_WITH_ID = 'src/pages/orders/GET_POST_ORDER_WITH_ID';
export const GET_POST_ORDER_WITH_ID_SUCCESS =
  'src/pages/orders/GET_POST_ORDER_WITH_ID_SUCCESS';
export const GET_POST_ORDER_WITH_ID_FAILED =
  'src/pages/orders/GET_POST_ORDER_WITH_ID_FAILED';

export const UPDATE_ORDER_STATUS = 'src/pages/orders/UPDATE_ORDER_STATUS';
export const UPDATE_ORDER_STATUS_SUCCESS =
  'src/pages/orders/UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_FAILED =
  'src/pages/orders/UPDATE_ORDER_STATUS_FAILED';

export const UPDATE_POST_ORDER_STATUS =
  'src/pages/orders/UPDATE_POST_ORDER_STATUS';
export const UPDATE_POST_ORDER_STATUS_SUCCESS =
  'src/pages/orders/UPDATE_POST_ORDER_STATUS_SUCCESS';
export const UPDATE_POST_ORDER_STATUS_FAILED =
  'src/pages/orders/UPDATE_POST_ORDER_STATUS_FAILED';

export const UPDATE_ORDER_DELIVERY_TYPE =
  'src/pages/orders/UPDATE_ORDER_DELIVERY_TYPE';
export const UPDATE_ORDER_DELIVERY_TYPE_SUCCESS =
  'src/pages/orders/UPDATE_ORDER_DELIVERY_TYPE_SUCCESS';
export const UPDATE_ORDER_DELIVERY_TYPE_FAILED =
  'src/pages/orders/UPDATE_ORDER_DELIVERY_TYPE_FAILED';

export const ADD_ORDER_DIMENSIONS = 'src/pages/orders/ADD_ORDER_DIMENSIONS';
export const ADD_ORDER_DIMENSIONS_SUCCESS =
  'src/pages/orders/ADD_ORDER_DIMENSIONS_SUCCESS';
export const ADD_ORDER_DIMENSIONS_FAILED =
  'src/pages/orders/ADD_ORDER_DIMENSIONS_FAILED';

export const UPDATE_ORDER_ITEM_STATUS: string =
  'src/pages/orders/UPDATE_ORDER_ITEM_STATUS';
export const UPDATE_ORDER_ITEM_STATUS_SUCCESS: string =
  'src/pages/orders/UPDATE_ORDER_ITEM_STATUS_SUCCESS';
export const UPDATE_ORDER_ITEM_STATUS_FAILED: string =
  'src/pages/orders/UPDATE_ORDER_ITEM_STATUS_FAILED';

export const ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM: string =
  'src/pages/orders/ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM';
export const ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_SUCCESS: string =
  'src/pages/orders/ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_SUCCESS';
export const ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_FAILED: string =
  'src/pages/orders/ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_FAILED';

export const DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM: string =
  'src/pages/orders/DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM';
export const DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_SUCCESS: string =
  'src/pages/orders/DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_SUCCESS';
export const DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_FAILED: string =
  'src/pages/orders/DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_FAILED';

export const ACTION_RETRIEVE_RUBIKA_ORDERS =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS';
export const ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS';
export const ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED';

export const SCHEDULE_ORDERS = 'src/pages/bundles/SCHEDULE_ORDERS';
export const SCHEDULE_ORDERS_SUCCESS =
  'src/pages/bundles/SCHEDULE_ORDERS_SUCCESS';
export const SCHEDULE_ORDERS_FAILED =
  'src/pages/bundles/SCHEDULE_ORDERS_FAILED';

export const CANCEL_ORDER = 'src/pages/orders/CANCEL_ORDER';
export const CANCEL_ORDER_SUCCESS = 'src/pages/orders/CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILED = 'src/pages/orders/CANCEL_ORDER_FAILED';

export const DELETE_POST_ORDER = 'src/pages/orders/DELETE_POST_ORDER';
export const DELETE_POST_ORDER_SUCCESS =
  'src/pages/orders/DELETE_POST_ORDER_SUCCESS';
export const DELETE_POST_ORDER_FAILED =
  'src/pages/orders/DELETE_POST_ORDER_FAILED';

export const GET_LOGS = 'src/pages/orders/GET_LOGS';
export const GET_LOGS_SUCCESS = 'src/pages/orders/GET_LOGS_SUCCESS';
export const GET_LOGS_FAILED = 'src/pages/orders/GET_LOGS_FAILED';

export const GET_ALL_ORDERS_REPORT = 'src/pages/orders/GET_ALL_ORDERS_REPORT';
export const GET_ALL_ORDERS_REPORT_SUCCESS =
  'src/pages/orders/GET_ALL_ORDERS_REPORT_SUCCESS';
export const GET_ALL_ORDERS_REPORT_FAILED =
  'src/pages/orders/GET_ALL_ORDERS_REPORT_FAILED';

export const UPDATE_ALL_ORDER_STATUS =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS';
export const UPDATE_ALL_ORDER_STATUS_SUCCESS =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS_SUCCESS';
export const UPDATE_ALL_ORDER_STATUS_FAILED =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS_FAILED';

export const UPDATE_ALL_ORDER_ASSIGN =
  'src/pages/orders/UPDATE_ALL_ORDER_ASSIGN';
export const UPDATE_ALL_ORDER_ASSIGN_SUCCESS =
  'src/pages/orders/UPDATE_ALL_ORDER_ASSIGN_SUCCESS';
export const UPDATE_ALL_ORDER_ASSIGN_FAILED =
  'src/pages/orders/UPDATE_ALL_ORDER_ASSIGN_FAILED';

export const ASSIGN_ORDER = 'src/pages/orders/ASSIGN_ORDER';
export const ASSIGN_ORDER_SUCCESS = 'src/pages/orders/ASSIGN_ORDER_SUCCESS';
export const ASSIGN_ORDER_FAILED = 'src/pages/orders/ASSIGN_ORDER_FAILED';

export const CHANGE_DELIVERY_TYPE = 'src/pages/orders/CHANGE_DELIVERY_TYPE';
export const CHANGE_DELIVERY_TYPE_SUCCESS =
  'src/pages/orders/CHANGE_DELIVERY_TYPE_SUCCESS';
export const CHANGE_DELIVERY_TYPE_FAILED =
  'src/pages/orders/CHANGE_DELIVERY_TYPE_FAILED';

export const GET_ORDER_ITEMS = 'src/pages/orders/GET_ORDER_ITEMS';
export const GET_ORDER_ITEMS_SUCCESS =
  'src/pages/orders/GET_ORDER_ITEMS_SUCCESS';
export const GET_ORDER_ITEMS_FAILED = 'src/pages/orders/GET_ORDER_ITEMS_FAILED';

export const CLEAR_ORDER = 'src/pages/orders/CLEAR_ORDER';

export const CREATE_ORDER_ITEMS = 'src/pages/orders/CREATE_ORDER_ITEMS';
export const CREATE_ORDER_ITEMS_SUCCESS =
  'src/pages/orders/CREATE_ORDER_ITEMS_SUCCESS';
export const CREATE_ORDER_ITEMS_FAILED =
  'src/pages/orders/CREATE_ORDER_ITEMS_FAILED';


export const GET_VITRIN_ORDERS = 'src/pages/orders/GET_VITRIN_ORDERS';
export const GET_VITRIN_ORDERS_SUCCESS =
  'src/pages/orders/GET_VITRIN_ORDERS_SUCCESS';
export const GET_VITRIN_ORDERS_FAILED =
  'src/pages/orders/GET_VITRIN_ORDERS_FAILED';


export const GET_VITRIN_ORDER_WITH_ID = 'src/pages/orders/GET_VITRIN_ORDER_WITH_ID';
export const GET_VITRIN_ORDER_WITH_ID_SUCCESS =
  'src/pages/orders/GET_VITRIN_ORDER_WITH_ID_SUCCESS';
export const GET_VITRIN_ORDER_WITH_ID_FAILED =
  'src/pages/orders/GET_VITRIN_ORDER_WITH_ID_FAILED';


export const GET_INCOMING_ORDERS = 'src/pages/orders/GET_INCOMING_ORDERS';
export const GET_INCOMING_ORDERS_SUCCESS =
  'src/pages/orders/GET_INCOMING_ORDERS_SUCCESS';
export const GET_INCOMING_ORDERS_FAILED =
  'src/pages/orders/GET_INCOMING_ORDERS_FAILED';

export const UPDATE_ORDER = 'src/pages/orders/UPDATE_ORDER';
export const UPDATE_ORDER_SUCCESS = 'src/pages/orders/UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILED = 'src/pages/orders/UPDATE_ORDER_FAILED';
export const RESEND_ORDER = 'src/pages/orders/RESEND_ORDER';
export const RESEND_ORDERS_SUCCESS = 'src/pages/orders/RESEND_ORDERS_SUCCESS';
export const RESEND_ORDERS_FAILED = 'src/pages/orders/RESEND_ORDERS_FAILED';
